import styled from 'styled-components'

const ShippingItemInfo = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`

export default ShippingItemInfo
